module.exports = "<div class=\"lp_ai_assist_dropdown_item\"></div>";